<template functional>
  <v-flex class="pl-block_card" :class="[data.staticClass]">
    <v-card>
      <v-card-title v-if="!props.noTitle">
        <div class="header">
          {{ props.title }}
        </div>
      </v-card-title>
      <v-divider></v-divider>
      <div v-if="props.loading" class="pa-5">
        <preloader :size="50" />
      </div>
      <v-card-text :class="props.classList">
        {{ classList }}
        <slot> </slot>
      </v-card-text>
    </v-card>
  </v-flex>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    noTitle: {
      type: Boolean,
      default: false,
    },
    classList: {
      type: String,
      default: '',
    },
  },
}
</script>
